// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

// Initialize Bootstrap tooltips and popovers on page load and Turbo visits
const initBootstrapComponents = () => {
  // Initialize tooltips
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
    const tooltip = bootstrap.Tooltip.getInstance(element)
    if (tooltip) tooltip.dispose()
    new bootstrap.Tooltip(element)
  })

  // Initialize popovers
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((element) => {
    const popover = bootstrap.Popover.getInstance(element)
    if (popover) popover.dispose()
    new bootstrap.Popover(element)
  })

  // Initialize dropdowns
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((element) => {
    const dropdown = bootstrap.Dropdown.getInstance(element)
    if (dropdown) dropdown.dispose()
    new bootstrap.Dropdown(element)
  })
}

document.addEventListener('DOMContentLoaded', initBootstrapComponents)
document.addEventListener('turbo:load', initBootstrapComponents)
